
const window = require('window');
const { document } = window;

const _ = require('lodash');

const $ = require('jquery');
require('./bootstrap');


/*
 * Extended bootstrap carousel
 *
 * Extra features:
 *  * `data-target` or `href` attributes are optional for `[data-slide]` and `[data-slide-to]`
 *	elements and default to `closest('[data-ride="carousel"]')`
 */

const Carousel = $.fn.carousel.Constructor;
const Plugin = $.fn.carousel;

const ExtendedCarousel = function () {
	Carousel.apply(this, arguments);
	this.constructor = ExtendedCarousel;

	this.$element
		.on('remove.page-common.visibility-condition.data-api', '.item', (e) => {
			this.removeItem(e.target);
			e.preventDefault();
		});

	return this;
};

const ExtendedPlugin = function (option) {
	return this.each(function () {
		const $this = $(this);
		let data = $this.data('bs.carousel');
		const options = $.extend(
			{},
			ExtendedCarousel.DEFAULTS,
			$this.data(),
			typeof option == 'object' && option
		);
		const action = typeof option == 'string' ? option : options.slide;

		if (!data) {
			$this.data('bs.carousel', (data = new ExtendedCarousel(this, options)));
		}

		if (typeof option == 'number') {
			data.to(option);
		} else if (action) {
			data[action]();
		} else if (options.interval) {
			data.pause().cycle();
		}
	});
};

ExtendedCarousel.prototype = _.extend(Object.create(Carousel.prototype), {
	removeItem (item) {
		const $item = $(item);

		const removeInitializedCarouselItem = ($item) => {
			const $indicators = this.$indicators.find('> li');
			const $indicator = $indicators.not('.active').last();

			this.$items = this.$items.filter(function (i, el) {
				return !$item.is(el);
			});

			activateSiblingAndRemove($indicator);
			$item.remove();
		};

		const isInitialized = Boolean(this.$items);
		const removingActiveItem = $item.is('.active');

		if (isInitialized) {
			if (removingActiveItem || this.sliding) {
				this.$element.one('slid.bs.carousel', () => {
					this.$items = this.$items.filter(function (i, el) {
						return !$item.is(el);
					});

					removeInitializedCarouselItem($item);
				});

				this.slide('next');
			} else {
				removeInitializedCarouselItem($item);
			}
		} else {
			removeUninitializedCarouselItem($item);
		}
	},
});

_.extend(ExtendedCarousel, Carousel);

$.fn.carousel = ExtendedPlugin;
$.fn.carousel.Constructor = ExtendedCarousel;

$.fn.carousel.noConflict = function () {
	$.fn.carousel = Plugin;
	$.fn.carousel.Constructor = Carousel;
	return this;
};

function clickHandler (e) {
	const $this = $(this);

	const targetAttr = $this.attr('data-target') || $this.attr('href');
	let $target;
	if (targetAttr) {
		$target = $(targetAttr);
	} else {
		$target = $this.closest('[data-ride="carousel"]');
	}

	if (!$target.hasClass('carousel')) {
		console.warn('Target for [data-slide] not found or is not .carousel', this);
	}

	const options = $.extend({}, $target.data(), $this.data());
	const slideIndex = $this.attr('data-slide-to');
	if (slideIndex) {
		options.interval = false;
	}

	ExtendedPlugin.call($target, options);

	if (slideIndex) {
		$target.data('bs.carousel').to(slideIndex);
	}

	e.preventDefault();
}

function activateSiblingAndRemove ($element) {
	if ($element.is('.active')) {
		const $sibling = $($element.next()[0] || $element.prev()[0]);
		$sibling.addClass('active');
	}
	$element.remove();
}

function removeUninitializedCarouselItem ($item) {
	const $carousel = $item.closest('[data-ride="carousel"]');
	const $indicators = $('> .carousel-indicators > li', $carousel);

	const $indicator = $indicators.not('.active').last();

	activateSiblingAndRemove($indicator);
	activateSiblingAndRemove($item);
}

function removeHandler (e) {
	removeUninitializedCarouselItem($(this));
	e.preventDefault();
}

const REMOVE_EVENT_ON_OFF = [
	'remove.page-common.visibility-condition.data-api',
	'[data-ride="carousel"] > .carousel-inner > .item',
	removeHandler,
];

$(document)
	.on(...REMOVE_EVENT_ON_OFF)
	.off('click.bs.carousel.data-api', '[data-slide]')
	.off('click.bs.carousel.data-api', '[data-slide-to]')
	.on('click.bs.carousel.data-api', '[data-slide]', clickHandler)
	.on('click.bs.carousel.data-api', '[data-slide-to]', clickHandler);

$(window)
	.off('load.bs.carousel.data-api')
	.on('load.bs.carousel.data-api', function () {
		$(document).off(...REMOVE_EVENT_ON_OFF);
		$('[data-ride="carousel"]').each(function () {
			const $carousel = $(this);
			ExtendedPlugin.call($carousel, $carousel.data());
		});
	});
